var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarbershop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.518,95v-0.379c0-2.229-1.809-4.039-4.039-4.039H29.199c-2.23,0-4.038,1.809-4.038,4.039V95H62.518z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.582,
    y: 73.293,
    width: 6.515,
    height: 14.338
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.995,
    y: 30.209,
    width: 46.574,
    height: 4.039
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.349,27.258h7.371L24.277,6.781c-0.131-1.107-1.137-1.898-2.244-1.767l-3.258,0.389    c-1.107,0.131-1.897,1.137-1.766,2.244L19.349,27.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.139,50.363H29.475l-1.569-13.164h-7.372l2.562,21.488c0.22,1.504,1.652,1.77,2.244,1.766l36.799,0.001    c1.115,0,2.02-0.904,2.02-2.02v-6.053C64.158,51.267,63.254,50.363,62.139,50.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.369,80.326c-0.441-0.005-0.877-0.207-1.163-0.587c-0.49-0.651-0.36-1.577,0.29-2.067    c5.559-4.191,15.864-4.409,18.891-4.376c0.814,0.008,1.468,0.676,1.459,1.491s-0.677,1.468-1.491,1.459    c-5.75-0.062-13.257,0.898-17.082,3.782C24.002,80.232,23.684,80.329,23.369,80.326z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.782,
    y: 24.165,
    width: 19.622,
    height: 3.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.239,
    y: 63.404,
    width: 5.2,
    height: 6.938
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.76,76.782 58.115,63.405 53.319,63.404 59.614,81.535 83.005,81.535 83.005,76.782  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbershop);
export default __webpack_public_path__ + "static/media/barbershop.24ee66a3b7539c0f55255b8de27dc968.svg";
export { ForwardRef as ReactComponent };